export const NO_SCENARIO_FOUND = 'NO_SCENARIO_FOUND';
export const SSR_HOST = 'www.wix.com';
export const SSR_PROTOCOL = 'http';
export const ORIGINAL_URL_HEADER = 'x-wix-metro-original-url';
export const ORIGINAL_HOST_HEADER = 'x-wix-metro-original-host';
export const ORIGINAL_PROTOCOL_HEADER = 'x-wix-metro-original-protocol';
// Nginx max url length (9kb)
export const MAX_NGINX_URL_LENGTH = 9216;
//# sourceMappingURL=constants.js.map